import { ShieldCheck, RefreshCw, Lock, Award, Headset, Globe2 } from "lucide-react";
import { CONFIG } from "../../config";

const ITEMS = [
  { icon: RefreshCw, title: `${CONFIG.GUARANTEE_DAYS}-day refund`, sub: "No questions" },
  { icon: ShieldCheck, title: "Secure checkout", sub: "256-bit SSL" },
  { icon: Lock, title: "Instant delivery", sub: ".ex5 by email" },
  { icon: Award, title: "Lifetime updates", sub: "Free upgrades" },
  { icon: Headset, title: "WhatsApp support", sub: "Setup help" },
  { icon: Globe2, title: "47+ countries", sub: "Global users" },
];

export default function TrustBar() {
  return (
    <section className="relative py-10 sm:py-14 border-y border-[#23232a]/60 bg-[#0c0c10]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-5">
        {ITEMS.map((it) => (
          <div key={it.title} className="flex items-center gap-3 min-w-0">
            <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg grid place-items-center border border-[#23232a] bg-[rgba(231,180,59,.05)] shrink-0">
              <it.icon className="w-4 h-4 sm:w-4.5 sm:h-4.5 text-[color:var(--gold)]" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="font-display font-bold text-[12px] sm:text-[13px] leading-tight truncate">{it.title}</div>
              <div className="font-mono text-[9px] sm:text-[10px] uppercase tracking-wider text-[color:var(--ink-mute)] mt-0.5 truncate">{it.sub}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
